import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { clearScrollPosition } from "@src/appV2/lib/utils/useScrollRestoration";
import { clearVirtuosoScrollRestoration } from "@src/appV2/lib/utils/useVirtuosoScrollRestoration";
import { useEffect } from "react";

import {
  DOCUMENT_SEARCH_SCROLL_POSITION_KEY,
  DOCUMENTS_PAGE_SCROLL_POSITION_KEY,
} from "./DocumentsPage/constants";
import { DocumentsRouter } from "./Router";

export function DocumentsContainer() {
  // Clear saved scroll position when leaving documents pages
  useEffect(() => {
    return () => {
      clearScrollPosition(DOCUMENTS_PAGE_SCROLL_POSITION_KEY);
      clearVirtuosoScrollRestoration(DOCUMENT_SEARCH_SCROLL_POSITION_KEY);
    };
  }, []);

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <DocumentsRouter />
    </ThemeProvider>
  );
}
